// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"338":"50f0676a","955":"e05352b2"}[chunkId] + ".js";
};